(() => {
  const selectors = {
    form: '[data-crm-contact-form]',
    status: '[data-crm-contact-status]',
    submitText: '[data-submit-text]',
  };

  function setStatus(node, state, message) {
    if (!node) return;
    node.hidden = false;
    node.dataset.state = state;
    node.textContent = message;
  }

  function clearStatus(node) {
    if (!node) return;
    node.hidden = true;
    node.dataset.state = '';
    node.textContent = '';
  }

  function readFormData(form) {
    const formData = new FormData(form);

    const professionalType = String(formData.get('professional_type') || '').trim();
    const jobTitle = String(formData.get('job_title') || '').trim();

    return {
      full_name: String(formData.get('full_name') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      phone: String(formData.get('phone') || '').trim(),
      country: String(formData.get('country') || '').trim(),
      company: String(formData.get('company') || '').trim(),
      // The CRM already stores job_title; professional_type rides along for when it learns the field.
      job_title: jobTitle || professionalType,
      professional_type: professionalType,
      message: String(formData.get('message') || '').trim(),
      company_fax: String(formData.get('company_fax') || '').trim(),
    };
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const statusNode = form.parentElement.querySelector(selectors.status);
    const submitButton = form.querySelector('[type="submit"]');
    const submitText = submitButton?.querySelector(selectors.submitText);
    const defaultButtonText = submitText?.textContent || '';
    const endpoint = form.dataset.crmEndpoint;
    const endpointMissingMessage = form.dataset.endpointMissingMessage || '';
    const submitErrorMessage = form.dataset.submitErrorMessage || '';
    const submitSendingText = form.dataset.submitSendingText || '';
    const successMessage = form.dataset.successMessage || '';

    clearStatus(statusNode);

    if (!endpoint) {
      setStatus(statusNode, 'error', endpointMissingMessage);
      return;
    }

    const payload = readFormData(form);
    const requestBody = {
      ...payload,
      form_name: form.dataset.formName || 'Shopify contact form',
      page_url: window.location.href,
      source: 'website',
      type: form.dataset.leadType || '',
      subtype: form.dataset.leadSubtype || '',
      website: window.location.origin,
    };

    submitButton?.setAttribute('aria-busy', 'true');
    if (submitButton) submitButton.disabled = true;
    if (submitText) submitText.textContent = submitSendingText;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        let errorMessage = submitErrorMessage;

        try {
          const payload = await response.json();
          if (payload?.error) errorMessage = payload.error;
        } catch {
          // Ignore JSON parse failures and fall back to generic copy.
        }

        throw new Error(errorMessage);
      }

      form.reset();
      setStatus(
        statusNode,
        'success',
        successMessage
      );
    } catch (error) {
      setStatus(
        statusNode,
        'error',
        error instanceof Error ? error.message : submitErrorMessage
      );
    } finally {
      submitButton?.removeAttribute('aria-busy');
      if (submitButton) submitButton.disabled = false;
      if (submitText) submitText.textContent = defaultButtonText;
    }
  }

  document.querySelectorAll(selectors.form).forEach((form) => {
    if (form.dataset.crmBound === 'true') return;
    form.dataset.crmBound = 'true';
    form.addEventListener('submit', handleSubmit);
  });
})();
